import React, { useEffect, useState } from 'react';
import {
  Box,
  Tabs,
  Tab,
  Paper,
  Typography,
  Container,
  Button,
} from '@mui/material';
import LocalDiningIcon from '@mui/icons-material/LocalDining';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LaunchIcon from '@mui/icons-material/Launch';
import { useNavigate } from 'react-router-dom';
import KitchenScreen from './KitchenScreen/KitchenScreen';
import OrdersScreen from './OrdersScreen/OrdersScreen';

const SCREEN_TAB_STORAGE_KEY = 'adminScreens.activeTab';

const ScreenMainPage = () => {
  const [tabValue, setTabValue] = useState(() => {
    const savedTab = Number(localStorage.getItem(SCREEN_TAB_STORAGE_KEY));
    return savedTab === 0 || savedTab === 1 ? savedTab : 0;
  });
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.setItem(SCREEN_TAB_STORAGE_KEY, String(tabValue));
  }, [tabValue]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
          إدارة الشاشات
        </Typography>
      </Box>

      <Paper sx={{ boxShadow: 3 }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
          sx={{
            borderBottom: '2px solid',
            borderBottomColor: 'divider',
            backgroundColor: 'background.paper',
          }}
        >
          <Tab
            icon={<LocalDiningIcon />}
            iconPosition="start"
            label="شاشة المطبخ"
            sx={{
              py: 2,
              fontWeight: 'bold',
              '&.Mui-selected': {
                backgroundColor: 'action.selected',
              },
            }}
          />
          <Tab
            icon={<LocalShippingIcon />}
            iconPosition="start"
            label="شاشة الأوردرات"
            sx={{
              py: 2,
              fontWeight: 'bold',
              '&.Mui-selected': {
                backgroundColor: 'action.selected',
              },
            }}
          />
        </Tabs>

        {/* محتوى التابات */}
        <Box sx={{ p: 3 }}>
          {tabValue === 0 && <KitchenScreen />}
          {tabValue === 1 && (
            <>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  mb: 2,
                }}
              >
                <Button
                  variant="contained"
                  startIcon={<LaunchIcon />}
                  onClick={() => navigate('/orders')}
                  sx={{ fontWeight: 'bold' }}
                >
                  الذهاب إلى صفحة الأوردرات
                </Button>
              </Box>
              <OrdersScreen />
            </>
          )}
        </Box>
      </Paper>
    </Container>
  );
};

export default ScreenMainPage;
